import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import { DateInput, } from 'ziphy-web-shared/basic/lib/forms/fields';
import { ConnectedGroup } from 'ziphy-web-shared/basic/lib/simple';
const ActivityFilters = ({ fields, values, onChange }) => {
    const { t } = useTranslation();
    const minDate = moment().add(-3, 'months');
    const maxDate = moment().add(3, 'months');
    return (_jsx("div", Object.assign({ className: "row" }, { children: _jsx("div", Object.assign({ className: "col-12 col-lg-6" }, { children: _jsx(ConnectedGroup, { renderItems: [
                    ({ getClass }) => {
                        return (_jsx(DateInput, { label: t('label.created_date_from'), field: {
                                value: fields.dateFrom.value,
                                onChange: fields.dateFrom.onChange,
                                isInvalid: fields.dateFrom.isInvalid,
                            }, mode: "sm", minDate: minDate, maxDate: maxDate, readonly: true, clear: true, innerClassName: getClass() }));
                    },
                    ({ getClass }) => {
                        return (_jsx(DateInput, { label: t('label.date_to'), field: {
                                value: fields.dateTo.value,
                                onChange: fields.dateTo.onChange,
                                isInvalid: fields.dateTo.isInvalid,
                            }, mode: "sm", minDate: minDate, maxDate: maxDate, readonly: true, clear: true, innerClassName: getClass() }));
                    },
                ] }) })) })));
};
export default observer(ActivityFilters);
